/** Dispatched after payment verification and subscription tier is stored (post-checkout). */
export const THEORYCOACH_SUBSCRIPTION_SUCCESS_INSTALL =
  'theorycoach:subscription-success-install';
